module.exports = __webpack_public_path__ + "img/no-activity.ca21e30c.png";